/**
 * @generated SignedSource<<f3510e2066b084a7346b98eb1f4d0431>>
 * @relayHash da6aa0e17936837b5fa5a9524961d535
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b4cae6efb677a44abc8a32127a4f651e050e203ec4c6bcb232458b0c53b292c5

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b4cae6efb677a44abc8a32127a4f651e050e203ec4c6bcb232458b0c53b292c5",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
